module.exports = __webpack_public_path__ + "static/hawaii-1-a675f534b20511faa9fda2dd0ea50742.png";